import { Bus, Fuel, Package } from "lucide-react";
import {
  ScheduleItem,
  DeliveryHistoryItem,
  ShareLinkItem,
} from "./types";

export const MOCK_SCHEDULES: ScheduleItem[] = [
  {
    id: "sch-01",
    reportTitle: "Weekly Attendance Defaulter Audit",
    reportId: "rep-att-01",
    frequency: "weekly",
    format: "pdf",
    channels: ["email", "workspace-inbox"],
    recipients: ["HOD", "Principal", "Academic Dean"],
    nextRunTime: "2026-08-04 08:00 AM",
    status: "active",
    createdBy: "System Scheduler",
    lastRunTime: "2026-07-28 08:00 AM",
  },
  {
    id: "sch-02",
    reportTitle: "Monthly Tuition Fee Reconciliation Register",
    reportId: "rep-fee-01",
    frequency: "monthly",
    format: "excel",
    channels: ["email", "shared-reports"],
    recipients: ["Finance Officer", "Super Admin"],
    nextRunTime: "2026-09-01 09:00 AM",
    status: "active",
    createdBy: "Chief Accountant",
    lastRunTime: "2026-08-01 09:00 AM",
  },
  {
    id: "sch-03",
    reportTitle: "Quarterly Executive Leadership Summary",
    reportId: "rep-exec-01",
    frequency: "quarterly",
    format: "pdf",
    channels: ["email", "workspace-inbox"],
    recipients: ["Principal", "Governing Board"],
    nextRunTime: "2026-10-01 10:00 AM",
    status: "active",
    createdBy: "Principal Office",
    lastRunTime: "2026-07-01 10:00 AM",
  },
  {
    id: "sch-04",
    reportTitle: "Daily Transport Bus Fleet Fuel Log",
    reportId: "rep-tr-01",
    frequency: "daily",
    format: "csv",
    channels: ["workspace-inbox"],
    recipients: ["Transport Manager"],
    nextRunTime: "2026-08-03 06:00 PM",
    status: "paused",
    createdBy: "Transport Office",
    lastRunTime: "2026-08-02 06:00 PM",
  },
];

export const MOCK_DELIVERY_HISTORY: DeliveryHistoryItem[] = [
  {
    id: "del-101",
    reportTitle: "Monthly Tuition Fee Reconciliation Register",
    scheduleId: "sch-02",
    deliveredAt: "2026-08-01 09:00 AM",
    channel: "email",
    format: "excel",
    recipientCount: 4,
    status: "success",
    fileSize: "2.4 MB",
  },
  {
    id: "del-102",
    reportTitle: "Weekly Attendance Defaulter Audit",
    scheduleId: "sch-01",
    deliveredAt: "2026-07-28 08:00 AM",
    channel: "workspace-inbox",
    format: "pdf",
    recipientCount: 12,
    status: "success",
    fileSize: "1.8 MB",
  },
  {
    id: "del-103",
    reportTitle: "Library Overdue Books & Fine Summary",
    deliveredAt: "2026-07-25 04:30 PM",
    channel: "email",
    format: "pdf",
    recipientCount: 1,
    status: "failed",
    fileSize: "0.5 MB",
    errorMessage: "SMTP Mailer Timeout (Retry Scheduled)",
  },
];

export const MOCK_SHARE_LINKS: ShareLinkItem[] = [
  {
    id: "share-01",
    reportTitle: "NAAC Accreditation Quality Audit 2026",
    reportId: "rep-naac-01",
    shareUrl: "https://erp.college.edu/share/naac-2026-audit-88a9",
    accessLevel: "read-only",
    privacy: "private",
    expiresAt: "2026-12-31",
    sharedWithRole: "NAAC Committee & Principal",
    viewCount: 42,
  },
  {
    id: "share-02",
    reportTitle: "Campus Placement Package Breakdown",
    reportId: "rep-plc-01",
    shareUrl: "https://erp.college.edu/share/placement-stats-2026",
    accessLevel: "read-only",
    privacy: "public",
    expiresAt: "2026-09-30",
    sharedWithRole: "All Students & Faculty",
    viewCount: 184,
  },
];
